namespace GeniuzPOS.ReportMasterData {
    export class Report_1310Columns {
        static columnsKey = 'ReportMasterData.Report_1310';
    }
}
